import React from 'react';
import { withProps } from 'recompose';
import styled from 'styled-components';
import * as madkomLogo from './../../assets/media/madkom_logo.png';

const MadkomLogo = ({ logoAlt, logoSrc }) =>
    <Logo
        alt={logoAlt}
        src={logoSrc} />

const Logo = styled.img`
    height: 24px;
    width: auto;
`;

const enhance = withProps({
    logoAlt: "Logo Madkom - Systemy Informatyczne",
    logoSrc: madkomLogo
})

export default enhance(MadkomLogo);


// WEBPACK FOOTER //
// ./src/components/madkom-logo/MadkomLogo.js